import { _ as __rest } from './_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { generateClasses } from '@ids/tools';
import { s as styleInject } from './style-inject.es.js';

var css_248z = ".ids-form-selection-group {\n  display: grid;\n  gap: var(--ids_size_general_8x);\n}\n.ids-form-selection-group__options {\n  display: grid;\n}\n.ids-form-selection-group--inline .ids-form-selection-group__options {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 0 var(--ids_size_general_24x);\n  width: 100%;\n}";
styleInject(css_248z);

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsFormSelectionGroup } from '@ids/react';
 * ```
 */
const IdsFormSelectionGroup = _a => {
  var {
      legend,
      legendProps,
      children,
      className = '',
      inline
    } = _a,
    props = __rest(_a, ["legend", "legendProps", "children", "className", "inline"]);
  const classes = generateClasses({
    'ids-form-selection-group': true,
    'ids-form-selection-group--inline': inline,
    [className]: className
  });
  const legendClasss = generateClasses({
    'ids-form-selection-legend': true,
    [(legendProps === null || legendProps === void 0 ? void 0 : legendProps.className) || '']: legendProps === null || legendProps === void 0 ? void 0 : legendProps.className
  });
  function renderChildren() {
    if (Array.isArray(children)) {
      return children.map(child => {
        var _a;
        return jsx("li", {
          children: child
        }, String((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.children));
      });
    }
    return children;
  }
  function renderLegend() {
    if (!legend) {
      return null;
    }
    if (typeof legend == 'string') {
      return jsx("legend", Object.assign({}, legendProps, {
        className: legendClasss
      }, {
        children: legend
      }));
    }
    return legend;
  }
  return jsxs("fieldset", Object.assign({
    className: classes
  }, props, {
    children: [renderLegend(), jsx("ul", Object.assign({
      className: "ids-form-selection-group__options"
    }, {
      children: renderChildren()
    }))]
  }));
};

export { IdsFormSelectionGroup as I };
//# sourceMappingURL=form-selection-group.js.map
